import { styled, Grid } from '@mui/material';

export const CardContentWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  border: `5px solid ${theme.palette.lightBg.main}`,
  borderRadius: '4px',
  padding: '0.5rem',
  gap: '0.4rem',
}));
